import store from '@/store'
let langList = null // 国际化数据
export function lang(str) {
  langList = store.state.base.langJson || {}
  return langList[str] || str || ''
}
